module.exports = __webpack_public_path__ + "img/play-alle.86d6c507.svg";